import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=5f5da3d7&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "loading.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/loading/loading.vue
// module id = 124
// module chunks = 0